import React from 'react'
import DataInput from './DataInput'
import DragAndDrop from './DragAndDrop'

import { uploadFile } from '../actions/UploadActions'
import { connect } from 'react-redux'
import { CircularProgress, withStyles } from '@material-ui/core'
import FileDataForm from './FileDataForm'

const styles = theme => ({})

const ACCEPTED_FILES = ['pdf'].map(ext => `.${ext}`).join(',')

const FileUpload = ({ url, uploading, uploadFile, onUpload }) => {
    return (
        <>
            {url ? (
                <FileDataForm url={url} onSubmit={onUpload} />
            ) : (
                <>
                    {uploading ? (
                        <CircularProgress />
                    ) : (
                        <DragAndDrop handleFile={uploadFile}>
                            <DataInput
                                handleFile={uploadFile}
                                label="Wybierz plik"
                                accept={ACCEPTED_FILES}
                            />
                        </DragAndDrop>
                    )}
                </>
            )}
        </>
    )
}

const mapStateToProps = ({ presto }) => {
    const { upload } = presto

    return upload
}

export default connect(mapStateToProps, {
    uploadFile,
})(withStyles(styles, { withTheme: true })(FileUpload))
